import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box, Grid, Step, Center, Stepper, StepTitle, StepIndicator, StepSeparator, useSteps } from '@chakra-ui/react';
import { Svg } from '../../base';
import { SimpleTable } from '../../tables';
const CokerResultFC = ({ data }) => {
    const resultsCount = data.length ?? 0;
    const { activeStep, setActiveStep } = useSteps({ index: 0, count: resultsCount });
    const steps = useMemo(() => {
        return data.map((item) => item.title) ?? [];
    }, [data]);
    const columns = useMemo(() => {
        return (data[activeStep]?.columns?.map((c, index) => ({
            name: c.title,
            columnTemplate: index === 0 ? '2fr' : '1fr',
            align: index === 0 ? 'left' : 'right',
            propertyName: 'col_' + index
        })) ?? []);
    }, [activeStep, data]);
    const rows = useMemo(() => {
        const rowsCount = data[activeStep]?.columns[0]?.values.length ?? 0;
        if (rowsCount === 0)
            return [];
        const rowsList = [];
        for (let i = 0; i < rowsCount; i++) {
            rowsList.push({
                key: i,
                value: data[activeStep].columns?.reduce((acc, cur, idx) => {
                    const colProperty = columns[idx]?.propertyName;
                    if (!colProperty) {
                        return acc;
                    }
                    acc[colProperty] = cur.values[idx]?.value?.toString() ?? '';
                    return acc;
                }, {})
            });
        }
        return rowsList;
    }, [activeStep, columns, data]);
    return (_jsxs(Box, { p: '0 8px 8px 8px', "data-testid": "CokerResults-test", children: [_jsx(Box, { padding: "20px 0 40px 0", children: _jsx(Stepper, { gap: "0", size: "m", index: activeStep, orientation: "horizontal", children: steps.map((step, index) => (_jsxs(Step, { children: [_jsx(StepIndicator, { onClick: () => setActiveStep(index), children: _jsx(Box, { width: "100%", height: "100%", border: "1px solid", borderColor: "white", borderRadius: "50%", bg: index <= activeStep ? 'accent' : 'white' }) }), _jsx(StepTitle, { children: _jsx(Box, { ml: "-11px", w: "30px", textAlign: "center", children: step }) }), _jsx(StepSeparator, {})] }, step))) }) }), _jsxs(Grid, { gridTemplateColumns: "1fr 1fr", children: [_jsx(SimpleTable, { columns: columns, rows: rows }), _jsxs(Center, { children: [activeStep === 0 && _jsx(Svg, { name: "CokerResult_0", width: 82, height: 192 }), activeStep === 1 && _jsx(Svg, { name: "CokerResult_25", width: 82, height: 192 }), activeStep === 2 && _jsx(Svg, { name: "CokerResult_50", width: 82, height: 192 }), activeStep === 3 && _jsx(Svg, { name: "CokerResult_75", width: 82, height: 192 }), activeStep === 4 && _jsx(Svg, { name: "CokerResult_100", width: 82, height: 192 })] })] })] }));
};
export const CokerResult = memo(CokerResultFC);
//# sourceMappingURL=CokerResult.js.map